'use client'

import * as React from 'react'
import type { Link as LinkSchema, Modal } from '@/contentful/generated/schemas'
import { getCtaLinkBehavior, getCtaLinkType } from '@/contentful/link-cta'

import { preventDefault } from '@/lib/utils'
import { Button } from '@/components/ui/button'
import { Link } from '@/components/ui/link'
import { openMemcoWindow } from '@/components/memco-modal'

type MemcoModalProps = {
  content: Modal
}

export function MemcoModal({ content }: MemcoModalProps) {
  if (!content.fields.trigger) return null

  return <MemcoLinkTrigger link={content.fields.trigger} />
}

export function MemcoLinkTrigger({ link }: { link: LinkSchema }) {
  const { href, name, variant } = link.fields
  if (!href || !name) return null

  const linkType = getCtaLinkType(link)
  const buttonVariant = variant || 'primary'
  return (
    <Button variant={buttonVariant} asChild className="w-fit">
      <Link
        role="button"
        href={href}
        onClick={preventDefault(openMemcoWindow)}
        {...getCtaLinkBehavior(link)}
        {...(linkType && { 'data-link-type': linkType })}
      >
        {name}
      </Link>
    </Button>
  )
}
